import { Component, Inject, Input } from '@angular/core';
import { UI_CONFIG } from '../ui.config';
import { UiConfig } from '../ui.interface';

@Component({
  selector: 'fl-picture',
  template: `
    <picture class="PictureElement"
      [attr.data-display]="display">
      <source [srcset]="_src">
      <img [src]="_src" [alt]="alt" [attr.data-display]="display" class="ImageElement">
    </picture>
  `,
  styleUrls: ['./picture.component.scss'],
})
export class PictureComponent {
  _src: string;
  @Input()
  set src(value: string) {
    this._src = `${this.uiConfig.assetsBaseUrl}/${value}`;
  }
  @Input() alt: string;
  @Input() display: 'block' | 'inline';

  constructor(@Inject(UI_CONFIG) private uiConfig: UiConfig) {}
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/app/@shared/ui/picture/picture.component.ts